import { useContext } from "react";
import { ActivityContext } from "./activity.context";

export function useActivity() {
	return useContext(ActivityContext);
}